import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-track-version',
  templateUrl: './create-track-version.component.html',
  styleUrls: ['./create-track-version.component.scss']
})
export class CreateTrackVersionComponent implements OnInit {
  selectedparent = 'Select'; 
  selectedversion = 'Select'; 
  selectedtrackend = 'Select'; 
  panelOpenState = false;
  inspanelOpenState = false;
  tvnpanelOpenState = false;
  sonpanelOpenState = false;
  vocpanelOpenState = false;
  lyricpanelOpenState = false;

  constructor() { }

  ngOnInit(): void {
  }

}
